module.exports = __webpack_public_path__ + "img/javascript.bfd17d9f.png";